import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@fontsource/space-grotesk/500.css";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/500.css";
import App from "./App.tsx";
import "./index.css";

const rootElement = document.getElementById("root");

if (typeof window !== "undefined") {
  window.addEventListener("error", () => showBootError());
  window.addEventListener("unhandledrejection", () => showBootError());
}

function showBootError() {
  if (!rootElement) return;
  if (rootElement.dataset.eridonBootError === "1") return;
  rootElement.dataset.eridonBootError = "1";
  rootElement.innerHTML = `
    <main style="min-height:100vh;display:flex;align-items:center;justify-content:center;padding:24px;background:#0d1120;color:#e2e8f0;font-family:Inter,system-ui,-apple-system,Segoe UI,Roboto,sans-serif;text-align:center;box-sizing:border-box;">
      <section style="max-width:420px;width:100%;padding:28px 20px;border:1px solid rgba(255,255,255,.12);border-radius:18px;background:rgba(255,255,255,.05);box-shadow:0 20px 60px rgba(0,0,0,.35);">
        <h1 style="margin:0 0 12px;font-size:24px;line-height:1.2;color:#fff;">ERIDON временно не открыл приложение</h1>
        <p style="margin:0 0 20px;color:#94a3b8;line-height:1.55;">Нажмите кнопку ниже — сайт откроется в облегчённом режиме без чёрного экрана.</p>
        <button id="eridon-retry" style="width:100%;border:0;border-radius:12px;padding:14px 18px;background:#4f46e5;color:#fff;font-weight:700;font-size:16px;">Обновить сайт</button>
      </section>
    </main>`;
  document.getElementById("eridon-retry")?.addEventListener("click", () => {
    window.location.reload();
  });
}

try {
  if (!rootElement) {
    throw new Error("Root element was not found");
  }

  createRoot(rootElement).render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
  (window as any).__eridonBooted = true;
} catch (_e) {
  showBootError();
}

// Background cleanup: kill any lingering service workers / Cache Storage
// from older builds. No redirects, no sessionStorage flags.
if (typeof window !== "undefined") {
  try {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .getRegistrations()
        .then((regs) => regs.forEach((r) => r.unregister()))
        .catch(() => undefined);
    }
    if ("caches" in window) {
      caches
        .keys()
        .then((names) => names.forEach((name) => caches.delete(name)))
        .catch(() => undefined);
    }
  } catch (_e) {
    // silently ignore
  }
}
